import { Component } from '@angular/core';
import { GenericService } from '../../generic.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MachineTypes, machineModels } from '../../../assets/data/deviceData';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { defaultLanguage } from '../../shared/constants/language.constants';
import { LandingService } from '../../landing-page/service/landing.service';
import { CrowdinService } from '../../shared/service/crowdin.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-esr-edit',
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './esr-edit.component.html',
    styleUrl: './esr-edit.component.scss'
})
export class EsrEditComponent {
  isFormValid: boolean = true;
  deviceData: any = {};
  deviceData$: any = null;
  machineTypes: any = MachineTypes;
  machineModels: any;
  isAddressValid: boolean = true;
  isCityValid: boolean = true;
  editForm!: FormGroup;
  translations: { [key: string]: string } = {};
  currentLanguage: string = defaultLanguage;
  languageOptions: Array<{ value: string }> = [];
  isLoadingTranslations = true;
  languageIndex: any;
  subs = new Subscription();

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private genericService: GenericService,
    private landingService: LandingService,
    private crowdinService: CrowdinService,
  ) {
    this.deviceData$ = this.genericService.deviceData.subscribe((data) => {
      if (data) {
        this.deviceData = data;
      }
    });
  }

  ngOnInit() {
    this.languageOptions = this.landingService.getLanguageOptions();

    const stored = localStorage.getItem('deviceData');
    const selectedName = stored
      ? JSON.parse(stored).languageSelected || defaultLanguage
      : defaultLanguage;
    this.currentLanguage = selectedName;

    this.subs.add(
      this.landingService.languageName$.subscribe((langName) => {
        this.currentLanguage = langName;
        this.translations = this.crowdinService.getAllTranslations();
      }),
    );

    this.landingService.loadTranslations(this.currentLanguage);
    this.initializeForm();
  }

  async languageChange(event: any) {
    const selectedLang = event.target.value;
    await this.landingService.loadTranslations(selectedLang);
  }

  initializeForm() {
    this.editForm = this.fb.group({
      address: [''],
      city: [''],
      machineType: [this.getMachineType()],
      machineModel: [this.getMachineModels()],
      businessName: [this.deviceData?.businessName],
      state: [this.deviceData?.state],
      zip: [this.deviceData?.zip],
    });
  }
  getMachineType() {
    let type;
    this.machineTypes.forEach((element: any) => {
      if (element.setValue.includes(this.deviceData?.productLine))
        type = element.value[this.languageIndex];
    });
    return type;
  }

  getMachineModels() {
    let typeID: any;
    let modelName: any;
    this.machineTypes.forEach((element: any) => {
      if (element.setValue.includes(this.deviceData?.productLine))
        typeID = element.type;
    });
    let models = machineModels;
    models.forEach((element: any) => {
      if (element.type == typeID) this.machineModels = element.values;
    });
    this.machineModels.forEach((element: any) => {
      if (element.setValue == this.deviceData?.modelNumber)
        modelName = element.value[this.languageIndex];
    });
    return modelName;
  }

  get machineType() {
    return this.editForm.get('machineType') as FormControl;
  }
  get machineModel() {
    return this.editForm.get('machineModel') as FormControl;
  }

  navigate() {
    const address = document.getElementById('address') as HTMLInputElement;
    const city = document.getElementById('city') as HTMLInputElement;
    if (address?.value || city?.value) {
      this.isFormValid = true;
      this.deviceData['languageSelected'] = this.currentLanguage;
      this.genericService.setLocalStorage(this.deviceData);
      this.genericService.deviceData.next(this.deviceData);
      this.router.navigate(['/esrSupportDetails']);
    } else {
      if (address?.value == null || address?.value == '')
        this.isAddressValid = false;
      else this.isAddressValid = true;
      if (city?.value == null || city?.value == '') this.isCityValid = false;
      else this.isCityValid = true;
      this.isFormValid = false;
      return;
    }
  }

  onAddressChange() {
    const address = document.getElementById('address') as HTMLInputElement;
    if (address?.value == null || address?.value == '')
      this.isAddressValid = false;
    else this.isAddressValid = true;

    const city = document.getElementById('city') as HTMLInputElement;
    if (city?.value && city?.value) this.isFormValid = true;
    else this.isFormValid = false;
  }

  onCityChange() {
    const city = document.getElementById('city') as HTMLInputElement;
    if (city?.value == null || city?.value == '') this.isCityValid = false;
    else this.isCityValid = true;

    const address = document.getElementById('address') as HTMLInputElement;
    if (address?.value && address?.value) this.isFormValid = true;
    else this.isFormValid = false;
  }

  onMachineTypeChange($event: any) {
    let typeID: any;
    let modelName: any;
    this.machineTypes.forEach((element: any) => {
      if (element.value.includes($event.target.value)) typeID = element.type;
    });
    let models = machineModels;
    models.forEach((element: any) => {
      if (element.type == typeID) this.machineModels = element.values;
    });
    this.machineModels.forEach((element: any) => {
      if (element.setValue == this.deviceData?.modelNumber)
        modelName = element.value;
    });
    this.editForm?.get('machineModel')?.patchValue('');
  }
}
